import { apiSlice } from "./apiSlice";
import { TABLE_URL } from "../constants";

const tableApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTableOrders: builder.query({
      query: (data) => ({
        url: `${TABLE_URL}/getMyOutletTables`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
  }),
});
export const { useGetTableOrdersQuery } = tableApiSlice;
